<template>
  <div>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="page-header bordered mb0">
            <div class="row align-items-end">
              <div class="col-md-8">
                <h1>
                  <i class="fa fa-gift" aria-hidden="true"></i>
                  {{ giftCard.title }}
                </h1>
              </div>
              <div class="col-md-4">
                <div v-if="giftCard.image_url">
                  <img :src="giftCard.image_url" class="img-fluid">
                </div>

                <div v-else class="text-center">
                  <i class="fa fa-picture-o" style="font-size: 10em;" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="content" class="item-single">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <div class="row justify-content-md-center has-sidebar">
              <div class="col-md-7 col-lg-8">
                <div class="card">
                  <div class="card-header" role="tab">
                    <h4 class="panel-title">Order Summary </h4>
                  </div>

                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              Amount
                            </td>
                            <td class="text-right">
                              {{ price / 100 | currency  }}
                            </td>
                          </tr>

                          <tr v-if="giftCard.limited_time_bonus_enabled && !giftCard.limited_time_bonus_out_of_date">
                            <td>
                              {{giftCard.bonus_percentage}}% bonus
                            </td>
                            <td class="text-right">
                              {{ calculateBonusPrice(price, giftCard.bonus_percentage) | currency }}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              Gift card balance
                            </td>
                            <td class="text-right">
                              {{ calculateGiftCardPrice() | currency  }}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <strong>Total credit card charge</strong>
                            </td>
                            <td class="text-right">
                              {{ (price / 100) | currency }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h4 class="panel-title">Gift Card Recipient (optional) </h4>
                  </div>

                  <div class="card-body">
                    <form>
                      <div class="form-group">
                        <label for="recipient_name">Recipient Name</label>
                        <input type="text" class="form-control form-control-lg"
                               name="recipient_name" v-model="recipientName" data-vv-as="Recipient Name"
                               placeholder="Who the gift is for"
                               v-validate="''"
                        />
                        <span v-show="errors.has('recipient_name')" class="input-error">
                          Please enter a recipient name.
                        </span>
                      </div>

                      <div class="form-group">
                        <label for="recipient_email">Recipient Email</label>
                        <input type="email" class="form-control form-control-lg"
                          name="recipient_email" v-model="recipientEmail" data-vv-as="Recipient Email"
                          v-validate="'email'" placeholder="To send gift notification"
                        />
                        <span v-show="errors.has('recipient_email')" class="input-error">
                          Please enter a valid email address.
                        </span>
                      </div>

                      <div class="form-group">
                        <label for="recipient_message">Recipient Message</label>
                        <textarea class="form-control form-control-lg" name="recipient_message"
                          v-model="recipientMessage" data-vv-as="Recipient Message" rows="3"
                          placeholder="Your personal note to your recipient"
                          v-validate="'max:2000'" />
                        <span v-show="errors.has('recipient_message')" class="input-error">
                          {{ errors.first('recipient_message') }}
                        </span>
                      </div>
                    </form>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header" role="tab">
                    <h4 class="panel-title">Your Information </h4>
                  </div>

                  <div class="card-body">
                    <span style="color: #e1474d;">(*) required fields</span>
                    <h3 class="subheadline">Contact Information</h3>
                    <form>
                      <div class="form-group">
                        <label for="first_name">First Name *</label>
                        <input type="text" class="form-control form-control-lg" name="first_name"
                          v-model="user.first_name" data-vv-as="First Name"
                          placeholder="Your first name" v-validate="'required|max:250'" />
                        <span v-show="errors.has('first_name')" class="input-error">
                          Please enter your first name.
                        </span>
                      </div>

                      <div class="form-group">
                        <label for="last_name">Last Name *</label>
                        <input type="text" class="form-control form-control-lg" name="last_name"
                          v-model="user.last_name" data-vv-as="Last Name"
                          placeholder="Your last name" v-validate="'required|max:250'" />
                        <span v-show="errors.has('last_name')" class="input-error">
                          Please enter your last name.
                        </span>
                      </div>

                      <div class="form-group">
                        <label for="email">Email *</label>
                        <input type="email" name="email" class="form-control form-control-lg"
                          placeholder="Your email address" v-model="user.email" v-validate="'required|email'"
                          data-vv-as="Email" ref="email">
                        <span v-show="errors.has('email')" class="input-error">
                          Please enter a valid email address.
                        </span>
                      </div>

                      <div class="form-group">
                        <label for="email_confirmation">Confirm Email *</label>
                        <input type="email" name="email_confirmation" v-validate="'required|confirmed:email'"
                          data-vv-as="Email confirmation" class="form-control form-control-lg"
                          placeholder="Confirm your email address" />
                        <span v-show="errors.has('email_confirmation')" class="input-error">
                          Please confirm your email address.
                        </span>
                      </div>

                      <select v-if="$localStorage.get('user_type') === 'staffer'" name="payment_type"
                              class="form-control form-control-lg ui-select"
                              v-model="paymentTypeSelected">
                        <option v-for="(paymentType, index) in paymentTypeList" :key="index"
                                :value="paymentType">
                          {{ paymentType.replace('_', ' ') }}
                        </option>
                      </select>

                      <div v-show="paymentTypeSelected === 'credit_card'">
                        <br/>
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="form-group">
                              <div ref="cardNumber" class="form-control form-control-lg"
                                   style="height: 2.4em; padding-top: .7em;">
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <div class="form-group">
                              <div ref="cardExpiry" class="form-control form-control-lg"
                                   style="height: 2.4em; padding-top: .7em;">
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <div class="form-group">
                              <div ref="cardCvc" class="form-control form-control-lg"
                                   style="height: 2.4em; padding-top: .7em;">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <span v-show="hasCardErrors" class="input-error">
                        {{ cardErrors }}
                      </span>

                      <br />

                      <div v-if="giftCard.organizer_email_opt_in" class="form-group">
                        <div class="checkbox">
                          <input type="checkbox" v-model="email_opt_in"
                            name="email_opt_in" id="email_opt_in">
                          <label for="email_opt_in">
                            {{ giftCard.organizer_name }} can send me emails about events and exclusive offers.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <label>
                          By clicking "Place Order", I accept the

                          <a href="javascript:;" @click="$bvModal.show('termsOfService')"
                             style="color: #007bff;">
                            Terms of Service
                          </a>
                          and have read the

                          <a href="javascript:;" @click="$bvModal.show('privacyPolicy')"
                             style="color: #007bff;">
                            Privacy Policy.
                          </a>
                        </label>
                      </div>
                    </form>

                    <br/>
                    <b-button class="btn btn-lg btn-primary btn-block"
                      @click="validate()">
                      Place Order
                    </b-button>
                  </div>
                </div>
                <img :class="'stripe-badge'" :src="require('../../assets/img/stripe_blurple.png')" />
              </div>

              <div class="col-md-5 col-lg-4 d-none d-md-block">
                <div id="sidebar" class="sidebar-right">
                  <div class="sidebar_inner">
                    <div id="feature-list" role="tablist">
                      <div class="card">
                        <h5 class="subheadline mt-0  mb-0">
                          Organizer
                        </h5>
                        <div class="card-body">
                          <strong> {{ giftCard.organizer_name }} </strong>
                          <br/>
                          <p>{{ giftCard.organizer_description}}</p>

                          <template v-if="giftCard.organizer_website">
                            <a :href="giftCard.organizer_website" target="_blank">
                              {{ giftCard.organizer_website }}
                            </a>
                            <br/>
                          </template>

                          <template v-if="giftCard.organizer_contact_phone_number">
                            <a :href="`tel:+1${extracNumbers(giftCard.organizer_contact_phone_number)}`"
                              rel="nofollow">
                              {{ giftCard.organizer_contact_phone_number }}
                            </a>
                            <br/>
                          </template>

                          <template v-if="giftCard.organizer_facebook_id">
                            <a :href="socialMediaLinks(giftCard.organizer_facebook_id, 'facebook')" target="_blank">
                              <i class="fa fa-facebook-official" aria-hidden="true"></i>
                              {{ giftCard.organizer_facebook_id }}
                            </a>
                            <br/>
                          </template>

                          <template v-if="giftCard.organizer_twitter_id">
                            <a :href="socialMediaLinks(giftCard.organizer_twitter_id, 'twitter')" target="_blank">
                              <i class="fa fa-twitter" aria-hidden="true"></i>
                              {{ giftCard.organizer_twitter_id }}
                            </a>
                            <br/>
                          </template>

                          <template v-if="giftCard.organizer_instagram_id">
                            <a :href="socialMediaLinks(giftCard.organizer_instagram_id, 'instagram')" target="_blank">
                              <i class="fa fa-instagram" aria-hidden="true"></i>
                              {{ giftCard.organizer_instagram_id }}
                            </a>
                            <br/>
                          </template>
                        </div>
                        <br/>

                        <b-button v-b-modal.formContactModal class="btn btn-lg btn-primary btn-block">
                          Contact Us
                        </b-button>

                        <ContactForm
                          :giftCard="giftCard">
                        </ContactForm>

                        <TermsOfService
                          :organizer_name="giftCard.organizer_name"
                          :organizer_contact_email="giftCard.organizer_contact_email"
                          :organizer_website="giftCard.organizer_website"
                          :organizer_state="giftCard.organizer_state"
                          :organizer_city="giftCard.organizer_city"
                          :organizer_country="giftCard.organizer_country"
                        ></TermsOfService>

                        <PrivacyPolicy
                          :organizer_name="giftCard.organizer_name"
                          :organizer_contact_email="giftCard.organizer_contact_email"
                          :organizer_website="giftCard.organizer_website"
                          :organizer_state="giftCard.organizer_state"
                          :organizer_city="giftCard.organizer_city"
                          :organizer_country="giftCard.organizer_country"
                        ></PrivacyPolicy>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <script v-html="giftCardStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import PurchaseService from '../../services/PurchaseService'
import ContactForm from '../common/ContactForm'
import GiftCardPublicService from '../../services/GiftCardPublicService'
import StructuredData from '../common/StructuredData'
import TermsOfService from '@/components/common/TermsOfService'
import PrivacyPolicy from '@/components/common/PrivacyPolicy'

let stripe = null
let elements = null
let cardNumber = null
let cardExpiry = null
let cardCvc = null
let baseStyles = { style: { base: { fontSize: '20px' } } }

export default {
  name: 'GiftCardPurchase',
  mixins: [StructuredData],
  components: {
    TermsOfService,
    PrivacyPolicy,
    ContactForm
  },
  data: function () {
    return {
      giftCardId: this.$route.params.id,
      price: this.$route.params.price || 0,
      user: {},
      email_opt_in: true,
      giftCard: this.$route.params.gift_card || {
        id: null,
        title: null,
        image_url: null,
        needLoading: true
      },
      paymentTypeList: ['cash', 'credit_card'],
      paymentTypeSelected: 'credit_card',
      hasCardErrors: false,
      cardErrors: null,
      giftCardStructuredData: {},
      recipientEmail: null,
      recipientMessage: null,
      recipientName: null
    }
  },
  mounted () {
    this.includeStripe()
  },
  created () {
    this.loadGiftCardStructuredData(this.giftCardId)
    if (this.giftCard.needLoading) {
      this.getGiftCard()
    }
  },
  beforeDestroy () {
    this.destroyStripeCardComponent()
  },
  methods: {
    configureStripe () {
      // eslint-disable-next-line no-undef
      stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
      elements = stripe.elements()

      this.destroyStripeCardComponent()

      cardNumber = elements.create(
        'cardNumber',
        { ...baseStyles, ...{ placeholder: 'Card number', showIcon: true } }
      )
      cardNumber.mount(this.$refs.cardNumber)

      cardCvc = elements.create('cardCvc', baseStyles)
      cardCvc.mount(this.$refs.cardCvc)

      cardExpiry = elements.create('cardExpiry', baseStyles)
      cardExpiry.mount(this.$refs.cardExpiry)
    },
    getGiftCard () {
      var self = this
      this.eventLoader = this.$loading.show()

      GiftCardPublicService.getGiftCard(this.giftCardId).then(response => {
        self.giftCard = response.data
        self.giftCard.needLoading = false
      }).finally(function () {
        self.eventLoader.hide()
      })
    },
    calculateGiftCardPrice () {
      if (this.giftCard.limited_time_bonus_enabled && !this.giftCard.limited_time_bonus_out_of_date) {
        return this.calculateBonusPrice(this.price, this.giftCard.bonus_percentage) + (this.price / 100)
      } else {
        return this.price / 100
      }
    },
    validate () {
      var self = this

      this.$validator.validateAll().then(result => {
        if (result) {
          self.confirmUser()
        }
      })
    },
    confirmUser () {
      var self = this
      var loader = this.$loading.show()

      this.$http.post('/users/get_user_for_purchase', { user: this.user }).then(response => {
        self.user = response.data

        // Generate purchase by payment type
        if (self.paymentTypeSelected === 'credit_card') {
          self.stripeTokenHandler()
        } else {
          self.makePurchase()
        }
      }).catch(error => {
        if (error) {
          self.$swal({
            title: 'Invalid contact information',
            type: 'error'
          })
        }
      }).finally(() => {
        loader.hide()
      })
    },
    stripeTokenHandler () {
      var self = this
      this.stripeTokenLoader = this.$loading.show()

      stripe.createToken(cardNumber).then(result => {
        if (result.error) {
          self.hasCardErrors = true
          self.cardErrors = result.error.message

          // Forcing the DOM to update so the Stripe Element can update.
          self.$forceUpdate()
        } else {
          self.makePurchase(result.token)
        }
      }).finally(() => {
        self.stripeTokenLoader.hide()
      })
    },
    makePurchase (token) {
      var self = this
      this.purchaseLoader = this.$loading.show()
      var params = {
        purchase: {
          user_id: this.user.id,
          gift_card_id: this.giftCardId,
          payment_type: this.paymentTypeSelected,
          email_opt_in: this.email_opt_in,
          gift_card_quantity: this.giftCardsQuantity,
          recipient_email: this.recipientEmail,
          recipient_message: this.recipientMessage,
          recipient_name: this.recipientName,
          price: this.price
        },
        charge: {
          token_information: token
        }
      }

      PurchaseService.createPurchase(params).then(response => {
        self.purchase = response.data

        self.$swal({
          title: 'Order received',
          text: 'Check your email shortly for your order confirmation.',
          type: 'success',
          confirmButtonColor: '#e1474d'
        }).then(() => {
          self.$router.push({
            name: 'giftCardPurchaseConfirmation',
            params: {
              gift_card_id: self.giftCardId,
              order_number: self.purchase.order_number
            }
          })
        })
      }).catch(error => {
        if (error) {
          var errorMsg = error.response.data.error || error.response.data.errors.join(', ')

          self.$swal({
            title: errorMsg,
            type: 'error'
          })
        }
      }).finally(() => {
        self.purchaseLoader.hide()
      })
    },
    destroyStripeCardComponent () {
      if (cardNumber) {
        cardNumber.destroy(this.$refs.cardNumber)
        cardExpiry.destroy(this.$refs.cardExpiry)
        cardCvc.destroy(this.$refs.cardCvc)

        cardNumber = null
        cardExpiry = null
        cardCvc = null
      }
    }
  }
}
</script>
